import { Paper, Typography } from "@mui/material";
import { pluralize } from "~/lib/pluralize";
import { ArrowUpward as ArrowUpwardIcon } from "@mui/icons-material";
import { Flex } from "~/components/Flex";
import { Link } from "react-router-dom";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";
import { ASSET_ID_PARAM } from "~/lib/urlUtils";
import { AttachIcon } from "~/icons";

type Props = {
  count: number;
  scope: SpaceOrWorkspaceScope;
  assetId?: string;
};

export const TicketsSummary = ({ count, scope, assetId }: Props) => {
  const queryParams = new URLSearchParams(scope.params);

  if (assetId) {
    queryParams.set(ASSET_ID_PARAM, assetId);
  }

  return (
    <Link
      to={`/space/tickets?${queryParams.toString()}`}
      style={{ textDecoration: "none", display: "block" }}
    >
      <Paper
        sx={{
          px: 2,
          py: 0.8,
          cursor: "pointer",
          backgroundColor: "background.light",
        }}
      >
        <Flex justifyContent="space-between">
          <Flex gap={1} alignItems="center">
            <AttachIcon sx={{ fontSize: 18 }} />
            <Typography fontWeight={700} fontSize={14}>
              {count} open related {pluralize("ticket", count)}
            </Typography>
          </Flex>
          <ArrowUpwardIcon
            sx={{ rotate: "90deg", fontSize: 18 }}
            color="primary"
          />
        </Flex>
      </Paper>
    </Link>
  );
};
